import { useQuery } from '@tanstack/react-query';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const WEBSITE_URL = 'https://tucarroporamerica.com';

async function fetchAdvisorsForWebsite() {
  const websitesRef = collection(db, 'websites');
  const websiteQuery = query(websitesRef, where('url', '==', WEBSITE_URL));
  const websiteDocs = await getDocs(websiteQuery);

  if (websiteDocs.empty) {
    throw new Error('Website not found in Firestore');
  }

  const websiteId = websiteDocs.docs[0].id;

  const advisorWebsitesRef = collection(db, 'advisor_websites');
  const advisorWebsiteQuery = query(advisorWebsitesRef, where('websiteId', '==', websiteId));
  const advisorWebsiteDocs = await getDocs(advisorWebsiteQuery);

  const advisorIds = advisorWebsiteDocs.docs.map((d) => d.data().advisorId);

  if (advisorIds.length === 0) {
    return [];
  }

  const advisorDocs = await Promise.all(
    advisorIds.map((advisorId) => getDoc(doc(db, 'advisors', advisorId)))
  );
  const advisors = advisorDocs
    .filter((d) => d.exists())
    .map((d) => ({ id: d.id, ...d.data() }));

  const tagIds = new Set();
  advisors.forEach((advisor) => {
    if (Array.isArray(advisor.tags)) {
      advisor.tags.forEach((tagId) => tagIds.add(tagId));
    }
  });

  const tagDocs = await Promise.all(
    Array.from(tagIds).map((tagId) => getDoc(doc(db, 'tags', tagId)))
  );
  const tagsMap = {};
  tagDocs.forEach((d) => {
    if (d.exists()) {
      tagsMap[d.id] = d.data();
    }
  });

  return advisors.map((advisor) => ({
    ...advisor,
    tags: Array.isArray(advisor.tags)
      ? advisor.tags.map((tagId) => tagsMap[tagId]).filter(Boolean)
      : [],
  }));
}

export function useAdvisors() {
  return useQuery({
    queryKey: ['advisors', 'tucarroporamerica'],
    queryFn: fetchAdvisorsForWebsite,
    staleTime: Infinity,
  });
}
